import React from "react";
import { Fragment } from "react";

function Vision() {
  const Visions = `${process.env.REACT_APP_URL_ASSETS}Assets/img/vision.png`;
  
  return (
    <Fragment>
      <section className="vision-mission-section">
        <div className="vision-mission-container">
          {/* Left: Image */}
          <div className="vision-image-wrapper">
            <img
              src={Visions}
              alt="Business vision - looking up at buildings"
              className="vision-image"
            />
          </div>

          {/* Right: Content */}
          <div className="vision-content-wrapper">
            <div className="vision-content-inner">
              {/* Vision Block */}
              <div className="vision-block" data-aos="fade-up" data-aos-duration="800">
                <h2 className="vision-heading">VISION</h2>
                <ul className="vision-list">
                  <li className="vision-list-item">
                    To be the premier Takaful provider driven by innovation and
                    unwavering adherence to Shariah principles, ensuring lasting
                    protection and peace of mind for our customers.
                  </li>
                </ul>
              </div>

              {/* Mission Block */}
              <div className="vision-block mission-block" data-aos="fade-up" data-aos-duration="1000">
                <h2 className="vision-heading">MISSION</h2>
                <ul className="vision-list">
                  <li className="vision-list-item">
                    To provide innovative and ethical Takaful solutions that deliver
                    unparalleled value and service to our participants, foster
                    employee growth, generate sustainable shareholder returns, and
                    proactively contribute to the community's well-being and a
                    sustainable environment.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default Vision;
